import { render, staticRenderFns } from "./EventPrices.vue?vue&type=template&id=6953c5e1"
import script from "./EventPrices.js?vue&type=script&lang=js&external"
export * from "./EventPrices.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports